export const defaultCountryList: string[] = [
  'GH',
  'GA',
  'GY',
  'GM',
  'GG',
  'GP',
  'GT',
  'GU',
  'GD',
  'GR',
  'GL',
  'GN',
  'GW',
  'NA',
  'NR',
  'NG',
  'AQ',
  'SS',
  'ZA',
  'NL',
  'NP',
  'NO',
  'NF',
  'NC',
  'NZ',
  'NU',
  'NE',
  'NI',
  'KR',
  'DK',
  'DO',
  'DM',
  'DE',
  'TL',
  'LA',
  'LR',
  'LV',
  'RU',
  'LB',
  'LS',
  'RE',
  'RO',
  'LU',
  'RW',
  'LY',
  'LT',
  'LI',
  'MG',
  'MQ',
  'MH',
  'YT',
  'MO',
  'MK',
  'MW',
  'MY',
  'ML',
  'IM',
  'MX',
  'MC',
  'MA',
  'MU',
  'MR',
  'MZ',
  'ME',
  'MS',
  'MD',
  'MV',
  'MT',
  'MN',
  'US',
  'UM',
  'VI',
  'MM',
  'FM',
  'VU',
  'BH',
  'BB',
  'VA',
  'BS',
  'BD',
  'BM',
  'BJ',
  'VE',
  'VN',
  'BE',
  'BY',
  'BZ',
  'BA',
  'BW',
  'BO',
  'BI',
  'BF',
  'BV',
  'BT',
  'MP',
  'BG',
  'BR',
  'BN',
  'WS',
  'SA',
  'GS',
  'SM',
  'ST',
  'PM',
  'EH',
  'SN',
  'RS',
  'SC',
  'LC',
  'VC',
  'KN',
  'SH',
  'SO',
  'SB',
  'SD',
  'SR',
  'LK',
  'SJ',
  'SZ',
  'SE',
  'CH',
  'ES',
  'SK',
  'SI',
  'SY',
  'SL',
  'SG',
  'AE',
  'AW',
  'AM',
  'AR',
  'AS',
  'IS',
  'HT',
  'IE',
  'AZ',
  'AF',
  'AD',
  'AL',
  'DZ',
  'AO',
  'AG',
  'AI',
  'ER',
  'EE',
  'EC',
  'ET',
  'SV',
  'GB',
  'VG',
  'IO',
  'YE',
  'OM',
  'AU',
  'AT',
  'HN',
  'AX',
  'WF',
  'JO',
  'UG',
  'UY',
  'UZ',
  'UA',
  'IQ',
  'IR',
  'IL',
  'EG',
  'IT',
  'IN',
  'ID',
  'JP',
  'JM',
  'ZM',
  'JE',
  'GQ',
  'KP',
  'GE',
  'CF',
  'TW',
  'DJ',
  'GI',
  'ZW',
  'TD',
  'CZ',
  'CL',
  'CM',
  'CV',
  'KZ',
  'QA',
  'KH',
  'CA',
  'KE',
  'KY',
  'KM',
  'CR',
  'CC',
  'CI',
  'CO',
  'CG',
  'CD',
  'CU',
  'KW',
  'CK',
  'HR',
  'CX',
  'KG',
  'KI',
  'CY',
  'TH',
  'TJ',
  'TZ',
  'TC',
  'TR',
  'TG',
  'TK',
  'TO',
  'TM',
  'TV',
  'TN',
  'TT',
  'PA',
  'PY',
  'PK',
  'PG',
  'PW',
  'PS',
  'FO',
  'PE',
  'PT',
  'FK',
  'PL',
  'PR',
  'FR',
  'GF',
  'TF',
  'PF',
  'FJ',
  'FI',
  'PH',
  'PN',
  'HM',
  'HU',
  'HK',
];
